import { useEffect, useRef, useState } from "react"
import { Button } from "react-aria-components"
import IconChevronUp from "../../../../../assets/icons/icon-chevron-up-blue.svg"
import IconChevronDown from "../../../../../assets/icons/icon-chevron-down-blue.svg"
import IconCopy from "../../../../../assets/icons/icon-copy.svg"
import { httpPost } from "../../../../../modules/Backend"
import Collapsible from "../../../../lib/Collapsible"
import { Virtuoso } from "react-virtuoso"
import { modalSignal } from "../../../Modal/ModalContainer"
import ConfirmModal from "../../../Modal/ConfirmModal"
import { toast } from "react-toastify"

interface ISidePanelAuditTrail {
    id: string,
    entityName: string,
}

interface IAccessToken {
    id: string,
    name: string,
    value: string
}

export default function SidePanelAccessTokens({ id, entityName }: ISidePanelAuditTrail) {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const [data, setData] = useState<IAccessToken[]>([])
    const [loading, setLoading] = useState<boolean>(false);

    const toastRef = useRef<any>(undefined)

    async function showData() {
        if (data.length == 0 && !loading) await getData()
        else { setCollapsed(prev => !prev) }
    }

    function copyToClipboard(value: string) {
        navigator.clipboard.writeText(value)
        if(!toast.isActive(toastRef.current)){
            toastRef.current = toast.success("Copied to clipboard", { position: "bottom-right" });
        }
    }

    function regenerateToken(id: string) {
        const regenerate = async () => {
            const result = await httpPost(`api/${entityName}/regenerate`, { id: id })

            const newData = [...data]
            let dataToUpdate = newData.find(x => x.id === id)

            if (dataToUpdate) {
                dataToUpdate.value = result.data.newValue
                setData(newData)
            }
        }

        modalSignal.value = <ConfirmModal ContinueFunc={regenerate} heading="Regenerate Access Token?"
            information={`Please be aware that once a new token is generated,
                        the current token will no longer be valid.
                        This means that any applications or services using the existing token
                        will need to be updated with the new token.`} />
    }

    async function getData() {
        setLoading(true)
        setCollapsed(false)
        const request = {
            accountId: id
        }

        var result = await httpPost(`api/${entityName}/list`, request)

        setData(result.data.accessTokens)
        setLoading(false);
    }

    useEffect(() => {
        setData([]);
        setCollapsed(true);
        setLoading(false)
    }, [id, entityName])

    return (
        <div className="side-panel-table__wrapper margin__top--s">
            <div className="display--flex flex__direction--row justifyContent--space-between padding__right--xxs">
                <h3>Access Tokens</h3>
                <Button className={"button button--with-icon alignSelf--baseline margin__right--xxs12"} onPress={showData}>
                    <img src={`${collapsed ? IconChevronDown : IconChevronUp}`}></img>
                </Button>
            </div>
            <Collapsible isCollapsed={collapsed}>
                <div className="margin__top--xxs">
                    {(data) &&
                        <Virtuoso
                            data={data}
                            style={{ height: 185 }}
                            initialItemCount={data.length}
                            totalCount={data.length}
                            itemContent={(_, token) => (
                                <div className="grid-x margin__top--xs alignItems--center">
                                    <p className="small-8 overflow--elipsis">{token.value}</p>
                                    <div className="small-4 display--flex alignItems--center gap--xs justifyContent--flex-end">
                                        <Button className={"button button--with-icon button"} onPress={() => copyToClipboard(token.value)}>
                                            <img src={IconCopy}></img>
                                        </Button>
                                        <Button className={"button button--primary button--small"} onPress={() => regenerateToken(token.id)}>
                                            Regenerate
                                        </Button>
                                    </div>
                                </div>
                            )}
                        />
                    }
                </div>
            </Collapsible>

        </div>
    )
}